/**
 * A lightweight version of TenantModel
 */
 export class AuthTenantResponseDto {
    id!: string;
    name?: string;
    locale!: string;
  }